import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Sec6 } from '../sections/sec6/sec6'
import style from './syllabus.module.css'

const Syllabus = () => {
  const nav = useNavigate()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })

  }, [])
  const silabus = [
    {
      title: "Introduction",
      list: [
        "Introduction to Computer Science",
        "Introduction to computers",
        "Algorithms and Data Structures",
        "database management &SQL",
        "Object-oriented programming",
        "python"
      ]
    },
    {
      title: "Git - source control",
      list: [
        "Source Control and Git",
        "The git DVCS model",
        "Git command line",
        "Branching, strategies",
        "Using git hooks",
        "Gitlab/Github installation and administration"
      ]
    },
    {
      title: "Docker and Docker-Compose ",
      list: [
        "Running docker containers",
        "Creating docker images using dockerfile",
        "Docker Build",
        "Docker multistage",
        "Coordinating small scale installations using docker-compose"
      ]
    },
    {
      title: "Software Lifecycle Management ",
      list: [
        "Managing software versioning",
        "Management in a versionless environment",
        "SAAS,PAAS,IAAS and Product release strategies",
        "Developing in a team",
        "struggle with git, basics of CI",
        "Web service with Flask,Python and Django"
      ]
    },
    {
      title: "Docker-Compose",
      list: [
        "Multi-container orchestration basics- single Host",
        "Docker networking",
        "Docker Volumes",
        "on-Premise strategies"
      ]
    },
    {
      title: "Continuous Integration",
      list: [
        "Jenkins Installation",
        "Jenkins administration and use",
        "Jenkins pipeline",
        "Modern build tools and Dependency (Maven & Npm)",
        "Artifact repository - Artifactory, Nexus",
        "Multi branch pipeline "
      ]
    },
  ]
  return (
    <div className={style.bg}>
    <div className={style.box}>
           <div style={{ position: 'fixed', zIndex: 99, bottom: '5%', left: 0 }}  >
        <Button onClick={()=> window.scrollTo(0, document.body.scrollHeight-1300) } className={style.btnMoreDetail} sx={{ color: 'white', padding: '5px 10px', borderRadius: '0 25px 25px 0', fontFamily: 'Heebo', fontWeight: '100', fontSize: '13px' }} variant="contained" color="success">
          לבדיקת התאמה ופרטים
        </Button>
      </div>
      <div className='d-flex align-items-center flex-column py-4 '>
        <div className={style.underlineGradient + " mb-3"}></div>
        <h1 className={style.bigTitle + ` text-center`}>DevOps Engineer Syllabus </h1>


      </div>
      <div className=" py-4">
        {silabus.map((item, i) => (

          <div key={i}>
            <h4 className={style.title}>{item?.title}</h4>
            <ul style={{ listStyleType: 'none' }} className={style.ul1}>
              {item?.list.map((item, j) => (
                <li  key={j} className={style.li}>○ {item} </li>
              ))}
               <li  >○ Cloud and Continuous Delivery </li>
            </ul>
            
          </div>
        ))}
        <p style={{cursor:'pointer'}} className='text-decoration-underline py-3' onClick={() => nav(-1)}>Back Home Page</p>
      </div>

    </div>
    <Sec6/>
    </div>
  )
}

export default Syllabus